import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Negotiation from "./sections/Negotiation";
import Advocate from "./sections/Advocate";
import StartYourNegotiation from "./sections/StartYourNegotiation";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Negotiation />
      <Advocate />
      <StartYourNegotiation />
      <Footer />
    </div>;
}